/**
 * @file Coordinates the authenticator setup and verification steps.
 */
import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { Space } from "antd";

import StartTotpSetup from "./StartTotpSetup";
import VerifyTotpSetup from "./VerifyTotpSetup";

type Props = {
  onSuccess: () => Promise<void> | void;
}

/**
 * Renders the start step, then the verify step once the setup data exists.
 */
const TotpSetup = ({
  onSuccess,
}: Props) => {
  const [ secretCode, setSecretCode ] = useState("");
  const [ setupUri, setSetupUri ] = useState("");

  /**
   * Reads the current user's access token from the Amplify session.
   */
  const getAccessToken = async () => {
    const user = await Auth.currentAuthenticatedUser();
    const { signInUserSession } = user;
    const { jwtToken } = signInUserSession.accessToken;

    return jwtToken;
  };

  const hasSetupData = secretCode.length > 0;

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <StartTotpSetup
        hasSetupData={hasSetupData}
        getAccessToken={getAccessToken}
        onSetupData={(nextSecretCode, nextSetupUri) => {
          setSecretCode(nextSecretCode);
          setSetupUri(nextSetupUri);
        }}
      />

      {
        hasSetupData && (
          <VerifyTotpSetup
            setupUri={setupUri}
            onSuccess={onSuccess}
            secretCode={secretCode}
            getAccessToken={getAccessToken}
          />
        )
      }
    </Space>
  );
};

export default TotpSetup;
